import * as React from 'react';
import jpgIcon from 'src/assets/img/icon-jpg.svg';
import mp4Icon from 'src/assets/img/icon-mp4.svg';
import otherIcon from 'src/assets/img/icon-other.svg';
import pdfIcon from 'src/assets/img/icon-pdf.svg';
import pngIcon from 'src/assets/img/icon-png.svg';
import svgIcon from 'src/assets/img/icon-svg.svg';
import { Box } from 'src/components/Box';

const icons: Record<string, string> = {
  jpeg: jpgIcon,
  jpg: jpgIcon,
  mp4: mp4Icon,
  pdf: pdfIcon,
  png: pngIcon,
  svg: svgIcon,
};

export interface FileIconProps {
  extension?: string;
}

export function FileIcon({ extension }: FileIconProps): React.ReactNode {
  let icon: string;

  if (!extension) {
    icon = otherIcon;
  } else {
    icon = icons[extension] ?? otherIcon;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'inline-flex',
        flex: '0 0 auto',
        justifyContent: 'center',
        width: '48px',
        height: '48px',
      }}
    >
      <Box
        alt="File"
        component="img"
        src={icon}
        sx={{ height: '100%', width: 'auto' }}
      />
    </Box>
  );
}
